import './styles/SlideProjector.scss';
import { useState, useRef, useEffect, createRef, Fragment } from 'react';
import { Browser } from '@capacitor/browser';
import { useHistory } from 'react-router';

//components
import ImagePreviewer from './ImagePreviewer';

//classes
import SlideProfile from '../classes/slideProfile';

//mui
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import ArrowRight from '@mui/icons-material/ArrowRight';
// import Close from '@mui/icons-material/Close'; ---deprecated of unused

const nonstate = {
    imageExtensions: ['.png', '.jpg', '.jpeg', '.gif'],
    videoExtensions: ['.mp4', '.wma', '.mov'],
    swipeTreshold: 25
}

interface Props {
    //slides: any[], attempt deprecated
    slides: SlideProfile[], // slides url, in png, jpg, jpeg, mp4, gif etc.
    switchMode?: string, //slide or default
    autoSlide?: number, //auto change slide in n seconds, 0 will turn off auto slide
    hideMainNav?: boolean, //left - right nav
    hideSubNav?: boolean, //bottom nav
    hideSwipeNav?: boolean //swipe to change picture
}

const SlideProjector: React.FC<Props> = ({ /*slides --atttempt deprecated*/ slides, switchMode, autoSlide, hideMainNav, hideSubNav, hideSwipeNav }) => {
    //states
    const [currentSlide, SetCurrentSlide] = useState(0);
    const [hideState, SetHideState] = useState<string[]>([]);
    // const [selectedSlide, SetSelectedSlide] = useState<string>(''); ---deprecated of unused

    //references
    //const currentSlideRef = useRef(0); attempt deprecated
    const currentSlideRef = useRef(0);
    const freezeAutoSlideRef = useRef(false);
    const unfreezeTimeoutRef = useRef<any>(null);
    //const slidesLengthRef = useRef(0); attempt deprecated
    const slidesLengthRef = useRef(0);
    const sourceTagRef = useRef<any[]/** HTMLImageElement | HTMLVideoElement */>([]);
    const touchPosXRef = useRef<number>(-999999999);
    const finalTouchPosXRef = useRef<number>(-999999999);

    //browser objs
    const history = useHistory();

    //watchers
    // useEffect(() => {
    //     console.log('SlideProjectorTest: ' + currentSlide);
    //     console.log('SlideProjectorTest currentSlideRef: ' + currentSlideRef.current);
    // }, [currentSlide]);

    useEffect(() => {
        if (autoSlide != undefined && autoSlide > 0) {
            const autoSlideInterval = setInterval(() => {
                if (!freezeAutoSlideRef.current !== undefined && !freezeAutoSlideRef.current && currentSlideRef.current !== undefined) {
                    currentSlideRef.current = (currentSlideRef.current < slidesLengthRef.current - 1) ? (currentSlideRef.current + 1) : 0;
                    SetCurrentSlide(currentSlideRef.current);
                }
            }, autoSlide);

            return () => {
                clearInterval(autoSlideInterval);
            };
        }
    }, []);
    useEffect(() => {
        //initialize hideState ---this state to be reanalyze everytime currentSlide update!
        const _hideState: string[] = [];
        if (slides.length > 0) {
            slides.map((slide: SlideProfile, i) => {
                let toPush = 'hide';
                if (i == currentSlide)
                    toPush = 'show';
                else if (currentSlide < slides.length - 2 && currentSlide > 1) {
                    if (i == currentSlide + 1)
                        toPush = 'prepare-right';
                    else if (i == currentSlide + 2)
                        toPush = 'hide-right';
                    else if (i == currentSlide - 1)
                        toPush = 'prepare-left';
                    else if (i == currentSlide - 2)
                        toPush = 'hide-left';
                }
                else if (currentSlide >= slides.length - 2 || currentSlide <= 1) {
                    if (currentSlide == 0) {
                        if (i == 1)
                            toPush = 'prepare-right';
                        else if (i == 2)
                            toPush = 'hide-right';
                        else if (i == slides.length - 1)
                            toPush = 'prepare-left';
                        else if (i == slides.length - 2)
                            toPush = 'hide-left';
                    } else if (currentSlide == 1) {
                        if (i == 2)
                            toPush = 'prepare-right';
                        else if (i == 3)
                            toPush = 'hide-right';
                        else if (i == 0)
                            toPush = 'prepare-left';
                        else if (i == slides.length - 1)
                            toPush = 'hide-left';
                    } else if (currentSlide == slides.length - 1) {
                        if (i == 0)
                            toPush = 'prepare-right';
                        else if (i == 1)
                            toPush = 'hide-right';
                        else if (i == slides.length - 2)
                            toPush = 'prepare-left';
                        else if (i == slides.length - 3)
                            toPush = 'hide-left';
                    } else if (currentSlide == slides.length - 2) {
                        if (i == slides.length - 1)
                            toPush = 'prepare-right';
                        else if (i == 0)
                            toPush = 'hide-right';
                        else if (i == slides.length - 3)
                            toPush = 'prepare-left';
                        else if (i == slides.length - 4)
                            toPush = 'hide-left';
                    }
                }
                _hideState.push(toPush);
            });
        }
        SetHideState([..._hideState]);
    }, [slides, currentSlide]);

    useEffect(() => {
        slidesLengthRef.current = slides.length;
    }, [slides]);

    //ui-functions
    const OnMainNavLeftClicked = () => {
        currentSlideRef.current = (currentSlide > 0) ? (currentSlide - 1) : (slides.length - 1);
        SetCurrentSlide(currentSlideRef.current);
        freezeAutoSlideRef.current = true;
        if (unfreezeTimeoutRef.current !== undefined)
            clearTimeout(unfreezeTimeoutRef.current);
        unfreezeTimeoutRef.current = setTimeout(() => {
            freezeAutoSlideRef.current = false;
        }, autoSlide);
    };
    const OnMainNavRightClicked = () => {
        currentSlideRef.current = (currentSlide < slides.length - 1) ? (currentSlide + 1) : 0;
        SetCurrentSlide(currentSlideRef.current);
        freezeAutoSlideRef.current = true;
        if (unfreezeTimeoutRef.current !== undefined)
            clearTimeout(unfreezeTimeoutRef.current);
        unfreezeTimeoutRef.current = setTimeout(() => {
            freezeAutoSlideRef.current = false;
        }, autoSlide);
    };
    const OnSubNavClicked = (to: number) => {
        currentSlideRef.current = to;
        SetCurrentSlide(currentSlideRef.current);
        freezeAutoSlideRef.current = true;
        if (unfreezeTimeoutRef.current !== undefined)
            clearTimeout(unfreezeTimeoutRef.current);
        unfreezeTimeoutRef.current = setTimeout(() => {
            freezeAutoSlideRef.current = false;
        }, autoSlide);
    }
    const OnSwipeNavTouchStart = (e: React.TouchEvent) => {
        touchPosXRef.current = e.touches[0].clientX;
    }
    const OnSwipeNavTouchMove = (e: React.TouchEvent) => {
        finalTouchPosXRef.current = e.touches[0].clientX;
    }
    const OnSwipeNavTouchEnd = () => {
        const diff = finalTouchPosXRef.current - touchPosXRef.current;
        if (Math.abs(diff) < 1000 && Math.abs(diff) > nonstate.swipeTreshold) {
            if (diff > 0) {
                //swipe left
                NavigateToLeft();
            } else if (diff < 0) {
                //swipe right
                NavigateToRight();
            }
        }
        touchPosXRef.current = -999999999;
        finalTouchPosXRef.current = -999999999;
    }

    //exe fucntions
    const RenderOptionPanel = () => {
        const subnavs: any[] = [];
        if (slides.length > 0) {
            slides.forEach((slide, i) => {
                subnavs.push(<button key={i} className={'subnav-btn ' + (currentSlide == i ? 'selected' : '')}></button>);
            });
        }
        return (
            <div id='slide-option-panel' className='slide-option-panel'>
                {
                    hideSwipeNav == undefined || !hideSwipeNav ?
                        < div id='swipe-nav' className='swipe-nav'
                            onClick={async () => {
                                slides[currentSlide].action == '' ?
                                    SimulateClickOnImagePreviewer(currentSlide)
                                    :
                                    (
                                        slides[currentSlide].action.includes('push') ?
                                            history.push(slides[currentSlide].action.split(':')[1])
                                            :
                                            Browser.open({ url: slides[currentSlide].action })
                                    )
                            }}
                            onTouchStart={(e: React.TouchEvent) => OnSwipeNavTouchStart(e)}
                            onTouchMove={(e: React.TouchEvent) => OnSwipeNavTouchMove(e)}
                            onTouchEnd={() => OnSwipeNavTouchEnd()}
                        />
                        :
                        null
                }
                {
                    hideMainNav == undefined || !hideMainNav ?
                        <Fragment>
                            <button id='mainnav-left-btn' className='mainnav left' onClick={() => { OnMainNavLeftClicked() }}><ArrowLeft /></button>
                            <button id='mainnav-right-btn' className='mainnav right' onClick={() => { OnMainNavRightClicked() }}><ArrowRight /></button>
                        </Fragment>
                        :
                        null
                }
                {
                    hideSubNav == undefined || !hideSubNav ?
                        <Fragment>
                            <div id='subnav-panel' className='subnav-panel'>
                                {slides.length > 0 ? slides.map((highlight, i) => <button key={i} onClick={() => { OnSubNavClicked(i) }} className={'subnav-btn ' + (currentSlide == i ? 'selected' : '')}></button>) : null}
                            </div>
                        </Fragment>
                        :
                        null
                }
            </div>
        );
    }
    const CheckIsVideo = (videoUrl: string) => {
        let isVideo = false;
        nonstate.videoExtensions.map((ext: string) => {
            if (videoUrl.includes(ext))
                isVideo = true;
        });

        return isVideo;
    }
    const CheckIsImage = (imgUrl: string) => {
        let isImage = false;
        nonstate.imageExtensions.map((ext: string) => {
            if (imgUrl.includes(ext))
                isImage = true;
        });

        return isImage;
    }
    const NavigateToLeft = () => {
        currentSlideRef.current = (currentSlide > 0) ? (currentSlide - 1) : (slides.length - 1);
        SetCurrentSlide(currentSlideRef.current);
        freezeAutoSlideRef.current = true;
        if (unfreezeTimeoutRef.current !== undefined)
            clearTimeout(unfreezeTimeoutRef.current);
        unfreezeTimeoutRef.current = setTimeout(() => {
            freezeAutoSlideRef.current = false;
        }, autoSlide);
    }
    const NavigateToRight = () => {
        currentSlideRef.current = (currentSlide < slides.length - 1) ? (currentSlide + 1) : 0;
        SetCurrentSlide(currentSlideRef.current);
        freezeAutoSlideRef.current = true;
        if (unfreezeTimeoutRef.current !== undefined)
            clearTimeout(unfreezeTimeoutRef.current);
        unfreezeTimeoutRef.current = setTimeout(() => {
            freezeAutoSlideRef.current = false;
        }, autoSlide);
    }
    const SimulateClickOnImagePreviewer = (slideIndex: number) => {
        const parentSlideContainer = sourceTagRef.current[slideIndex];
        const ImagePreviewerBtn = parentSlideContainer.querySelector('.ImagePreviewer-btn') as HTMLButtonElement;
        if(ImagePreviewerBtn) {
            ImagePreviewerBtn.click();
        } else {
            console.log('SlideProjectorErr: ImagePreviwerBtn Unfound');
        }
    }

    return (
        <div className='SlideProjector'>
            {/* redner slides */}
            {slides.length > 0 ? slides.map((slide: SlideProfile, i) => {
                return (
                    <div className={'SlideProjector-screen ' + (switchMode == undefined ? 'default' : switchMode) + ' ' + hideState[i]} key={slide.src + i} id={'slide-' + i}>
                        {
                            CheckIsImage(slide.src) ?
                                <div
                                    className={'slide-img ' + ((sourceTagRef.current[i] != undefined) && (sourceTagRef.current[i].naturalWidth > sourceTagRef.current[i].naturalHeight * 1.1) ? 'landscape' : '')}
                                    ref={_ref => (_ref != null ? sourceTagRef.current[i] = _ref : null)}
                                    id={'slide-img-' + i}
                                    /*src={slide.src} --deprecated to imagePreviewer*/>
                                    <ImagePreviewer src={slide.src}/>
                                </div>
                                :
                                (
                                    CheckIsVideo(slide.src) ?
                                        <video
                                            className={'slide-video ' + ((sourceTagRef.current[i] != undefined) && (sourceTagRef.current[i].naturalWidth > sourceTagRef.current[i].naturalHeight * 1.1) ? 'landscape' : '')}
                                            ref={_ref => (_ref != null ? sourceTagRef.current[i] = _ref : null)}
                                            loop autoPlay muted playsInline>
                                            <source src={slide.src} type="video/mp4" />
                                        </video>
                                        :
                                        null
                                )
                        }
                    </div>
                );
            }) : null}
            { RenderOptionPanel() }
            {/* <div className={'SlideProjector-view-slide-menu ' + (selectedSlide != '' ? '' : 'hide')}>
                <img className='SlideProjector-view-slide-img' src={selectedSlide} />
                <button className='SlideProjector-view-slide-close-btn' onClick={() => SetSelectedSlide('')}><Close /></button>
            </div> --deprecated to imagePreviewer */}
        </div>
    );
};

export default SlideProjector;